import cx from 'clsx';

import { SelectOverrideClassNames } from '../../inputs';
import { InputStyleProps } from '../../inputs/types';

import classes from './GroupSelect.module.css';

interface GroupSelectStyleProps extends InputStyleProps {
  pos?: 'left' | 'right';
  fixedLeftDropdown?: boolean;
}

export const GroupSelectOverrideClassNames = (props: GroupSelectStyleProps) => {
  const selectClasses = SelectOverrideClassNames(props);

  return {
    ...selectClasses,
    input: cx(selectClasses.input, {
      [classes.input]: !props.pos || props.pos === 'right',
      [classes.inputLeft]: props.pos === 'left'
    }),
    dropdown: cx(selectClasses.dropdown, {
      [classes.fixedLeftDropdown]: props.fixedLeftDropdown
    }),
    selectContainer: cx(classes.selectContainer, {
      [classes.selectContainerSmall]: props.size === 'xs',
      [classes.selectContainerLarge]: props.size !== 'xs'
    })
  };
};
